import { useEffect, useState } from "react";
import { getOtherRefDetails } from "../../api/keyvalue";
import LoadingSpinner from "../LoadingSpinner";
import MapComponent from "../maps/MapComponent";
import { MAP_TYPES } from "../../const";

const LocationDetails = ({ locationId, locationCustomerId }) => {
  const [mapLocations, setMapLocations] = useState([]); // [ { lat: 0, lng: 0 }
  const [requestLocation, setRequestLocation] = useState({
    locationName: "",
    rlkAddress: "",
    rlkEmail: "",
    rlkContactNumber: "",
    rlkLon: "",
    rlkLat: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      if (!locationCustomerId || !locationId) return;
      const locationResponse = await getOtherRefDetails({
        type: "location_customer",
        value: locationCustomerId.toString(),
        param2: locationId.toString(),
      });
      const locationDetails =
        locationResponse && locationResponse.length > 0
          ? locationResponse[0]
          : {};

      setMapLocations([
        {
          lat: locationDetails.retField10,
          lng: locationDetails.retField9,
        },
      ]);
      setRequestLocation({
        locationName: locationDetails.retField1,
        rlkAddress: locationDetails.retField2,
        rlkEmail: locationDetails.retField6,
        rlkContactNumber: locationDetails.retField5,
        rlkLon: locationDetails.retField9,
        rlkLat: locationDetails.retField10,
      });

      setIsLoading(false);
    })();
  }, [locationCustomerId, locationId]);

  return (
    <div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <form className="ui form">
          <div style={{ display: "flex", height: "50vh", minWidth: "30vw" }}>
            <div className="ui segment" style={{ marginRight: "10px" }}>
              <h4 className="ui dividing header">Location Details</h4>
              <div className="two fields">
                <div className="field">
                  <label>Location Name</label>
                  <input
                    type="text"
                    name="location_address"
                    value={requestLocation.locationName}
                    readOnly
                  />
                </div>
                <div className="field">
                  <label>Location Address</label>
                  <input
                    type="text"
                    name="location_address"
                    value={requestLocation.rlkAddress}
                    readOnly
                  />
                </div>
              </div>
              <div className="two fields">
                <div className="field">
                  <label>Contact Number</label>
                  <input
                    type="tel"
                    name="contact_number"
                    value={requestLocation.rlkContactNumber}
                    readOnly
                  />
                </div>
                <div className="field">
                  <label>Email</label>
                  <input
                    type="text"
                    name="location_email"
                    value={requestLocation.rlkEmail}
                    readOnly
                  />
                </div>
              </div>
              <div className="two fields">
                <div className="field">
                  <label>Longitude</label>
                  <input
                    type="text"
                    name="longitude"
                    value={requestLocation.rlkLon}
                    readOnly
                  />
                </div>
                <div className="field">
                  <label>Latitude</label>
                  <input
                    type="text"
                    name="latitude"
                    value={requestLocation.rlkLat}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div>
              <MapComponent
                type={MAP_TYPES.STATIC}
                initialLocations={mapLocations}
                activeTab="request-creation"
              />
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default LocationDetails;
